module.exports = __webpack_public_path__ + "assets/img/14_1469_big.6aaa2ef1.jpg";